import { ToggleButton as MuiToggleButton, type ToggleButtonProps as MuiToggleButtonProps } from '@mui/material';
import type { MouseEvent } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type ValueHandler<Value> = (event: MouseEvent<HTMLElement>, value: Value) => void;

type Props<Value extends NonNullable<unknown>> = WithoutStyleOverrides<
  Omit<MuiToggleButtonProps, 'value' | 'onChange' | 'onClick'>
> & {
  value: Value;
  onChange?: ValueHandler<Value>;
  onClick?: ValueHandler<Value>;
};

export function ToggleButton<Value extends NonNullable<unknown>>(props: Props<Value>) {
  return <MuiToggleButton {...props} />;
}

export type { Props as ToggleButtonProps };
